export default {
      id: "CAD-usage",
      viewBox: "0 0 21.6 16.2",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#CAD",
      toString: function () {
        return this.url;
      }
    }